import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';

/**
 * Gets minutes saved using traffic data
 * @returns Minutes saved using traffic data
 */
export function getDashboardDeviceStatsMinutesSavedUsingTrafficData(
  this: unknown,
  startDate: Date,
  endDate: Date
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetStatsEnvironment.resolve(this)
            .dashboardDeviceStatsDevicesMinutesSavedUsingTrafficDataUrl
        }?startTimestamp=${startDate.toISOString()}&endTimestamp=${endDate.toISOString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        event: z.string(),
        totalMinutesSaved: z.number(),
      })
    )
  );
}
